import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { CustomerInfo_$reflection, MachineInfo_$reflection } from "../Shared/ApiDataTypes.js";
import { record_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";

export class MachineViewInfo extends Record {
    constructor(Machine, Customer) {
        super();
        this.Machine = Machine;
        this.Customer = Customer;
    }
}

export function MachineViewInfo_$reflection() {
    return record_type("Kundeweb.Machine.Types.MachineViewInfo", [], MachineViewInfo, () => [["Machine", MachineInfo_$reflection()], ["Customer", CustomerInfo_$reflection()]]);
}

